import { useAutoneTranslation } from '@autone/translations';
import { forwardRef } from 'react';

import { ShareIcon } from '../../../icons';

import { CopyButton, type CopyButtonSpecialisedProps } from './CopyButton';

export const ShareURLButton = forwardRef<
  HTMLButtonElement,
  CopyButtonSpecialisedProps
>(({ ...props }, ref) => {
  const { common } = useAutoneTranslation();
  const copyText = window.location.href;

  return (
    <CopyButton
      ref={ref}
      copyText={copyText}
      tooltipText={common('tooltips.share')}
      icon={ShareIcon}
      {...props}
    />
  );
});
